import * as React from 'react';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export default function FirstComponent({dateTimeToDoToDo, onDateToDoToDoChange}) {
  // date timeToDoToDo is stored as UTC time in the database dayjs(dateTimeToDoToDo) makes it local time 
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Paper elevation={3} style={{padding: 8}}>
      <Typography variant="h6" gutterBottom>Date to do the todo ...</Typography>  
      <DateTimePicker 
        disablePast
        label="date and time to do the to do" 
        value={dayjs(dateTimeToDoToDo)} 
        onChange={(newValue) => onDateToDoToDoChange(newValue)}
        />
      </Paper>  
    </LocalizationProvider>
  );
}